module.exports = "/ui/image/logo.5a8f49f792d7b85a312d9da676987321.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 1084
// module chunks = 0